import React, { useState, useRef, useEffect } from 'react';
import { Dropdown } from 'bootstrap';
import { Card } from './Card';
import { HistoricalMenu } from '../historical/HistoricalMenu';
import { TimeLapse } from '../../model/TimeLapse';
import { AnalyticType } from '../../model/AnalyticType';
import { HistoricalChart } from '../historical/HistoricalChart';
import { Filter } from '../../model/Filter';
import { ISaleService } from '../../services/ISaleService';
import { Information } from '../Information';
import { t } from '../../i18n';

const HistoricalCard = ({ filter, shared, saleService }: Props) => {
  const [timeLapse, setTimeLapse] = useState(TimeLapse.hours);
  const [primaryOption, setPrimaryOption] = useState(AnalyticType.traffic);
  const [secondaryOption, setSecondaryOption] = useState<AnalyticType | undefined>(undefined);
  const timeLapseToggleRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    const onDocumentClick = (event: MouseEvent) => {
      const target = event.target as Node;
      const toggle = timeLapseToggleRef.current;
      if(!toggle || toggle.getAttribute('aria-expanded') !== 'true' || toggle.contains(target)) {
        return;
      }
      const menu = toggle.nextElementSibling;
      if(menu && menu.contains(target)) {
        return;
      }
      Dropdown.getInstance(toggle)?.hide();
    };
    document.addEventListener('click', onDocumentClick);
    return () => document.removeEventListener('click', onDocumentClick);
  }, []);

  const onToggleTimeLapse = () => {
    timeLapseToggleRef.current && Dropdown.getOrCreateInstance(timeLapseToggleRef.current).toggle();
  }

  const onSelectTimeLapse = (timeLapse: string) => {
    setTimeLapse(timeLapse as TimeLapse);
    timeLapseToggleRef.current && Dropdown.getInstance(timeLapseToggleRef.current)?.hide();
  }

  const onChangeOptions = (primaryOption: AnalyticType, secondaryOption?: AnalyticType) => {
    setPrimaryOption(primaryOption);
    setSecondaryOption(secondaryOption);
  }

  return (
    <Card className="">
      <div className="card-body">
        <div className="d-flex align-items-center mb-4">
          <div className="d-flex flex-grow-1">
            <Information id="historical" content={<h5 className="card-title text-start me-2">{t('cards.historical')}</h5>} />
            <Information id="historical" showMore={true} />
          </div>
          <div className="btn-group">
            <button type="button" className="btn btn-label-secondary text-dark">
              {t(`historical.timeLapse.${timeLapse}`)}
            </button>
            <button ref={timeLapseToggleRef} type="button" className="btn btn-label-secondary dropdown-toggle dropdown-toggle-split text-black" data-bs-toggle="dropdown" aria-expanded="false" onClick={onToggleTimeLapse}>
            </button>
            <ul className="dropdown-menu">
              {
                Object.values(TimeLapse).map(option =>
                  <li key={option}>
                    <span className={`dropdown-item ${option === timeLapse ? 'active' : ''}`} onClick={() => onSelectTimeLapse(option)}>{t(`historical.timeLapse.${option}`)}</span>
                  </li>
                )
              }
            </ul>
          </div>
        </div>
        <div className="row">
          <div className={`col-3 order-2 ${shared ? 'col-lg-12 order-lg-1' : 'order-2'}`}>
            <HistoricalMenu onChange={onChangeOptions} />
          </div>
          <div className={`col-9 order-1 ${shared ? 'col-lg-12 order-lg-2 mt-3' : 'order-1'}`}>
            <HistoricalChart primaryOption={primaryOption} secondaryOption={secondaryOption} timeLapse={timeLapse} filter={filter} saleService={saleService} />
          </div>
        </div>
      </div>
    </Card>
  );
}

interface Props {
  filter: Filter,
  shared: boolean,
  saleService: ISaleService
}

export { HistoricalCard };